<template>
  <div class="form-group">
    <label for="details" class="font-weight-bold">{{ label }}</label>
    <slot />
    <small
      id="passwordHelpBlock"
      class="form-text text-danger"
      v-if="hasErrors"
    >
      {{ firstErrorMessage }}
    </small>
  </div>
</template>

<script>
import { singleErrorExtractorMixin } from "vuelidate-error-extractor";

export default {
  mixins: [singleErrorExtractorMixin],
  props: {
    label: {
      type: String,
      default: ""
    }
  }
};
</script>
